// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ProductFiscalMissingResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/product_fiscal/missing
 *
 * The catalog-fiscal readiness list: active products visible to the
 * franchise with no effective NCM. Feeds the pre-flight check the next
 * milestone (BR emission planner) consumes before it will emit anything.
 */
import type { So_ProductFiscalMissingRow } from './So_ProductFiscalMissingRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type So_ProductFiscalMissingResponseDados = So_ProductFiscalMissingRow[];

export type So_ProductFiscalMissingResponse = ApiResponse<So_ProductFiscalMissingResponseDados>;

registerResponseContract('So_ProductFiscalMissingResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_product_id:   { type: 'number',  required: true },
      so_product_name: { type: 'string',  required: true },
      so_product_sku:  { type: 'string',  required: false },
    },
  },
})
